import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    formContainer: 'mt-8 mb-12 flex flex-col gap-8 max-md:mt-6 max-md:gap-6',
    formTitle: 'heading-m max-md:heading-s mb-4 !font-[450]'
  }
});
